module.exports = __webpack_public_path__ + "img/mimeal1.5da086c2.png";